import {Box, Typography as T, useTheme} from "@mui/material";
import {Cell, Label, Pie, PieChart} from "recharts";
import React from "react";
import {compactInfoFontSize, h2FontSize} from "src/theme";

const CustomInnerChartLabel = ({
  viewBox,
  total = 54
}: {
  viewBox: any,
  total: number
}) => {
  const {cx, cy} = viewBox;
  // crude centering
  const singleDigitXOffset = 10;
  let numberLeftShift = singleDigitXOffset;
  if (total > 99)
    numberLeftShift = singleDigitXOffset + 22;
  else if (total > 10)
    numberLeftShift = singleDigitXOffset + 10;

  return (
    <React.Fragment>
      <text x={cx - numberLeftShift} y={cy + 7}>
        <tspan
          style={{
            textAlign: 'right',
            fontWeight: 'normal',
            fontSize: h2FontSize,
          }}
        >
          {total}
        </tspan>
      </text>
      <text x={cx - 21} y={cy + 20}>
        <tspan
          style={{
            fontSize: "0.6em",
          }}
        >
          Total Apps
        </tspan>
      </text>
    </React.Fragment>
  );
};

export const DashboardDonutChart = (
  props: { data: any, total: number }
) => {
  const theme = useTheme();

  return (
    <Box
      sx={{width: '230px'}}
    >
      <PieChart

        width={190}
        height={190}
        style={{
          margin: "auto",
          // marginTop: '8px',
          textAlign: "center"
        }}
      >
        <Pie
          dataKey="value"
          data={props.data}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={95}
          // label={(entry) => `${entry.value} ${entry.name} Apps`}
        >
          <Cell fill={theme.more.riskyRed}/>
          <Cell fill={theme.more.andyGreen}/>

          <Label
            position="center"
            content={
              // @ts-ignore
              <CustomInnerChartLabel total={props.total}/>
            }
          />
        </Pie>
        {/*<Tooltip/>*/}
      </PieChart>
    </Box>
  );
}

export function CustomOuterChartLabel(props: {
  count: number,
  label: any,
  color: string
}) {
  return <Box
    sx={{
      width: '100%',
      minWidth: '130px',
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    }}
  >
    <Box
      sx={{
        height: "15px",
        width: "15px",
        backgroundColor: props.color,
        // marginBottom: '0.4rem',
      }}
    />
    <T
      sx={{
        fontSize: '2.0rem',
        color: props.color,
        marginBottom: 0,
        paddingBottom: 0,
      }}
    >
      {props.count}
    </T>
    <T
      sx={{
        marginTop: '-4px',
        paddingTop: 0,
        fontSize: compactInfoFontSize,
        width: '80%'
      }}
    >
      {props.label}
    </T>
  </Box>;
}
